<template>
  <div class="container-fluid col-12 col-lg-10" id="container">

    <div class="calculadora-cabecalho">
      <nav class="breadcrumb-calculadora" style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='%236c757d'/%3E%3C/svg%3E&#34;);" aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link to="/" class="text-decoration-none page-header-eyebrow">
            <b class="page-header-eyebrow">Projetos</b>
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link
            :to="`/app/project/${calculo.codProjeto}`"
            class="text-decoration-none"
          >
            <b class="page-header-eyebrow">Projeto</b>
          </router-link>
        </li>    
        <li class="breadcrumb-item active" aria-current="page">Componente</li>
      </ol>
      </nav>

      <div class="badges-calculadora">
        <span class="azul badge bg-primary">
          <b>Data de Criação: {{ converterDataBrasil(calculo.dataCriacao) }}</b>
        </span>
        <span class="azul badge bg-primary">
          <b>Autor(a): {{ abreviarNome(calculo.autor) }}</b>
        </span>
      </div>
    </div>

    <section class="calculadora-resumo">
      <!-- TÍTULO -->
      <div class="calculadora-identificacao">
        <p class="page-header-eyebrow">COMPONENTE DE BOCAL</p>
        <h1 class="calculadora-titulo">
          {{ calculo.nomeCalculo }}
        </h1>
        <p class="calculadora-subtitulo">
          Calculadora: <strong>{{ calculo.nomeCalculadora }}</strong>
        </p>
      </div>

      <figure class="calculadora-ilustracao">
        <img
          src="../componentes/img/7.png"
          alt="Desenho do Componente"
          class="img-componente-calc"
        />
        <figcaption>Ilustração do componente</figcaption>
      </figure>
    </section>

    <section class="calculadora-impressao">
      <div>
        <h2>Imprimir componente</h2>
        <p>Imprime um PDF com todos os dados do componente.</p>
      </div>
      <button type="button" class="btn btn-secundario" @click="imprimir()">
        Imprimir
      </button>
    </section>

    <!-- BOTÕES DE AÇÃO -->
    <div class="row g-2 justify-content-end">

      <!-- CALCULAR -->
      <div class="col-12 col-md-auto">
        <button
          type="button"
          class="botao-azul btn btn-primary w-100"
          @click="calcular"
        >
          Calcular
        </button>
      </div>

      <!-- SALVAR -->
      <div class="col-6 col-md-auto">
        <button
          class="botao-azul btn btn-primary w-100"
          @click="salvarCalculo()"
        >
          Salvar
        </button>
      </div>

    </div>

    <BocalCalculatorComponent :bocalCalculatorProps="bocalCalculator" :designData="designData" ref="bocalCalculatorForm" @temperatura-fora-faixa="abrirAlertaTemperaturaForaFaixa"/>

    <!-- BOTÕES DE AÇÃO -->
    <div class="row g-2 justify-content-end">

      <!-- CALCULAR -->
      <div class="col-12 col-md-auto">
        <button
          type="button"
          class="botao-azul btn btn-primary w-100"
          @click="calcular"
        >
          Calcular
        </button>
      </div>

      <!-- SALVAR -->
      <div class="col-6 col-md-auto">
        <button
          class="botao-azul btn btn-primary w-100"
          @click="salvarCalculo()"
        >
          Salvar
        </button>
      </div>

    </div>

    <!-- MODAIS -->
    <AlertModal
      :visible="alertModal.visible"
      :title="alertModal.title"
      :message="alertModal.message"
      :type="alertModal.type"
      @close="fecharAlert"
    />

    <LoadingModal
      :visible="loading.visible"
      :title="loading.title"
      :message="loading.message"
    />

  </div>
</template>

<script>
import { getUsuario } from '@/utils/authStorage';
// Componentes
import BocalCalculatorComponent from '@/components/calculadoras/BocalCalculatorComponent.vue';
import DesignData from '@/models/calculadoras/DesignData.js';
import BocalCalculator from '@/models/calculadoras/BocalCalculator.js';
import AlertModal from '@/componentesTelas/AlertModal.vue';
import LoadingModal from '@/componentesTelas/LoadingModal.vue';
import { logoBase64 } from './imgBase64/logoBase64.js';
import { drawingBocalBase64 } from './imgBase64/drawingBocalBase64.js';
import legendaDrawingBocal from '@/components/img/calculator-bocal/legenda-bocal-recortada.png';

import { jsPDF } from "jspdf";

export default {
  name: "CalculatorBocal",
  props: ["cod"],
  data() {
    return {
      calculo: {},
      designData: new DesignData(),
      bocalCalculator: new BocalCalculator(),
      usuarioLogado: null,

      // Modal de loading
      loadingModal: null,
      loadingModalAberto: false,

      // Modal de loading
      loading: {
        visible: false,
        title: 'Carregando dados',
        message: 'Aguarde um momento...'
      },

      // Modal genérico
      alertModal: {
        visible: false,
        title: '',
        message: '',
        type: 'info'
      },
    };
  },
  components: {
    BocalCalculatorComponent,
    AlertModal,
    LoadingModal
  },
  mounted(){
    const usuarioSalvo = getUsuario();
    this.usuarioLogado = usuarioSalvo ? {
      ...usuarioSalvo,
      nome: usuarioSalvo.nome
    } : null;
    this.topoPagina();
    this.abrirLoading();
    this.carregarCalculo(this.cod);
  },
  created(){
    window.scrollTo(0, 0);
    this.topoPagina();
  },
  updated(){
    setTimeout(() => {
      this.topoPagina();
    }, 1);
  },
  methods: {

    abrirAlert(title, message, type = 'info') {
      this.alertModal = {
        visible: true,
        title,
        message,
        type
      };
    },

    abrirAlertaTemperaturaForaFaixa({ temperatura, minimo, maximo }) {
      this.abrirAlert(
        "Sistema",
        `A temperatura informada (${temperatura} °C) esta fora do intervalo permitido (${minimo} °C a ${maximo} °C).`,
        "warning"
      );
    },

    fecharAlert() {
      this.alertModal.visible = false;
    },

    abrirLoading() {
      this.loading.visible = true;
    },

    fecharLoading() {
      this.loading.visible = false;
    },

    calcular() {
      const form = this.$refs.bocalCalculatorForm.$refs.formCalculo;

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      if (!this.bocalCalculator.tensaoAdmissivelBocal) {
        form.querySelector('select[required]')?.focus();
        return;
      }

        // Se passou em tudo, aí sim calcula
      form.requestSubmit();

        this.abrirAlert(
            "Sistema",
            "Cálculos realizados com sucesso.",
            "success"
        );
    },

    verResultados() {
      // Scroll para os resultados
      this.$nextTick(() => {
        const el = document.getElementById('calculation-results');
        if (el) {
          el.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    },

    abreviarNome(nome) {
      if (!nome) return '';

      const partes = nome
        .trim()
        .split(' ')
        .filter(Boolean); // 🔑 remove strings vazias

      if (partes.length === 1) return partes[0];

      return `${partes[0]} ${partes[partes.length - 1]}`;
    },

    converterDataBrasil(data) {
      if (!data) return '';

      const partes = data.split('-');
      if (partes.length !== 3) return data;

      return `${partes[2]}/${partes[1]}/${partes[0]}`;
    },

    topoPagina() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },

    async carregarDesignTemperatureElementoPai() {

      try {
        const response = await fetch(
          `${process.env.VUE_APP_BACKEND_URL}/buscar-design-temperature-pressure-elemento-pai/${this.calculo.elementoPaiCod}`,
          {
            method: "GET",
            headers: { "Content-Type": "application/json" }
          }
        );

        if (!response.ok) {
          throw new Error("Design Temperature não encontrado");
        }

        const data = await response.json();

        this.bocalCalculator.temperaturaProjeto = data.designTemperature;

        this.bocalCalculator.pressaoProjeto = data.designPressure;

      } catch (error) {
        console.error("Erro ao carregar Design Temperature:", error);
      }
    },

    async carregarInsideDiameterElementoPai() {

      try {
        const response = await fetch(
          `${process.env.VUE_APP_BACKEND_URL}/buscar-inside-diameter-elemento-pai/${this.calculo.elementoPaiCod}`,
          {
            method: "GET",
            headers: { "Content-Type": "application/json" }
          }
        );

        if (!response.ok) {
          throw new Error("Design Temperature não encontrado");
        }

        const data = await response.json();

        this.bocalCalculator.diametroInternoCasco = data.insideDiameter;

      } catch (error) {
        console.error("Erro ao carregar Design Temperature:", error);
      }
    },

    async carregarMininumRequiredThicknessElementoPai() {

      try {
        const response = await fetch(
          `${process.env.VUE_APP_BACKEND_URL}/buscar-mininum-required-thickness-elemento-pai/${this.calculo.elementoPaiCod}`,
          {
            method: "GET",
            headers: { "Content-Type": "application/json" }
          }
        );

        if (!response.ok) {
          throw new Error("Mininum Required Thickness não encontrado");
        }

        const data = await response.json();

        this.bocalCalculator.espessuraMinimaCasco = data.designThickness

      } catch (error) {
        console.error("Erro ao carregar Mininum Required Thickness:", error);
      }
    },

    async carregarDesignDataPorCod(codProjeto) {
      try {
          const response = await fetch(
              `${process.env.VUE_APP_BACKEND_URL}/buscar-design-data/${codProjeto}`,
              {
                  method: "GET",
                  headers: { "Content-Type": "application/json" }
              }
          );

          if (!response.ok) {
              throw new Error("Design Data não encontrado");
          }

          const data = await response.json();

          // mantém a instância da classe DesignData
          Object.assign(this.designData, data.designData.designData);

          // Copia campos do design data
          this.bocalCalculator.designPressureInternal = this.designData.designInternalPressure;
          this.bocalCalculator.designTemperature = this.designData.designTemperature;

      } catch (error) {
          console.error("Erro ao carregar Design Data:", error);
      }
    },

    async carregarTensaoEspessuraMinimaElementoPai() {

      try {
        const response = await fetch(
          `${process.env.VUE_APP_BACKEND_URL}/buscar-dados-tensao-espessura-minima-elemento-pai/${this.calculo.elementoPaiCod}`,
          {
            method: "GET",
            headers: { "Content-Type": "application/json" }
          }
        );

        if (!response.ok) {
          throw new Error("Dados de Tensão e Espessura Mínima não encontrados");
        }

        const data = await response.json();

        this.bocalCalculator.materialCasco = data.materialCasco;
        this.bocalCalculator.tensaoAdmissivelCasco = data.tensaoAdmissivelCasco;
        this.bocalCalculator.espessuraMinimaCasco = data.espessuraMinimaCasco;
        this.bocalCalculator.espessuraNominalCasco = data.espessuraNominalCasco;

      } catch (error) {
        console.error("Erro ao carregar Dados de Tensão e Espessura Mínima:", error);
      }
    },

    salvarCalculo() {
      let calculo = {
        cod: this.cod,
        bocalCalculator: this.bocalCalculator,
      };

      fetch(`${process.env.VUE_APP_BACKEND_URL}/salvar-calculo`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ calculo }),
        mode: 'cors',
      })
        .then(response => response.json())
        .catch(error => {
          console.error('Erro ao enviar dados para o servidor:', error);
        });
        this.abrirAlert("Sistema", "Dados salvos com sucesso.", "info");
        this.topoPagina();
        // this.carregarCalculo(this.cod);
    },

    carregarCalculo(cod) {
      
      fetch(
        `${process.env.VUE_APP_BACKEND_URL}/buscar-calculo/${cod}?email=${this.usuarioLogado.email}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
          mode: "cors",
        }
      )
        .then((response) => {

          // 🔐 BACKEND decide o acesso
          if (response.status === 401 || response.status === 403) {
            window.location.href = '/';
            throw new Error('Acesso negado');
          }

          if (!response.ok) {
            throw new Error('Erro ao carregar cálculo');
          }

          return response.json();
        })
        .then((data) => {
          if (!data || !data.calculo) {
            console.error("Resposta inválida do servidor:", data);
            return;
          }

          // 1 - CÁLCULO
          Object.assign(this.calculo, data.calculo);

          // 2 - DADOS ESPECÍFICOS DO CALCULADOR
          Object.assign(
            this.bocalCalculator,
            data.calculo.bocalCalculator
          );

          // 3 - CARREGA O DESIGN TEMPERATURE DO ELEMENTO PAI
          this.carregarDesignTemperatureElementoPai();

          // 4 - DESIGN DATA PELO PROJETO
          this.carregarDesignDataPorCod(this.calculo.codProjeto);

          // 5 - CARREGA DADOS DE TENSÃO E ESPESSURA MÍNIMA DO ELEMENTO PAI
          this.carregarTensaoEspessuraMinimaElementoPai();

          // 6 - CARREGA DADOS DE DIÂMETRO INTERNO DO ELEMENTO PAI
          this.carregarInsideDiameterElementoPai();

          // 7 - CARREGA CAMPO Minimum Required Thickness (Without Corrosion Allowance)
          this.carregarMininumRequiredThicknessElementoPai();

          this.topoPagina();
        })
        .catch((error) => {
          console.error("Erro ao carregar dados do cálculo:", error);
        })
        .finally(() => {
          this.fecharLoading();
        });
    },

    adicionarPaginacao(doc) {
      const totalPaginas = doc.internal.getNumberOfPages();
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.height;

      for (let i = 1; i <= totalPaginas; i++) {
        doc.setPage(i);
        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
        doc.setTextColor(150);

        const texto = `Página ${i} de ${totalPaginas}`;
        const textWidth = doc.getTextWidth(texto);
        doc.text(texto, (pageWidth - textWidth) / 2, pageHeight - 10);

        doc.setTextColor(0);
      }
    },

    async imprimir() {
      this.loading = {
        visible: true,
        title: 'Gerando PDF',
        message: 'Aguarde enquanto o documento e preparado...'
      };
      await this.$nextTick();
      await new Promise(resolve => requestAnimationFrame(resolve));

      const doc = new jsPDF();

      /* =========================
        FONTES
      ========================== */
      const pageHeight = doc.internal.pageSize.height;
      const pageWidth = doc.internal.pageSize.getWidth();
      let y = 20;

      const f = this.bocalCalculator;
      const minimumShellThickness = f.soldaCostado === "1"
        ? Number(f.espessuraMinimaCasco || 0) * Number(f.eficienciaJuntaCasco || 0)
        : Number(f.espessuraMinimaCasco || 0);
      const nominalThicknessValid = f.validNominalThickness ?? (
        Number(f.espessuraNominalCasco || 0) >= minimumShellThickness
      );

      /* =========================
        PAGE BREAK
      ========================== */
      const checkPage = (extra = 10) => {
        if (y + extra >= pageHeight - 20) {
          doc.addPage();
          y = 20;
        }
      };

      /* =========================
        HELPERS
      ========================== */
      const title = (text) => {
        checkPage(20);
        doc.setFont("helvetica", "bold");
        doc.setFontSize(16);
        doc.text(text, 20, y);
        y += 14;
      };

      const subtitle = (text) => {
        checkPage(15);
        doc.setFont("helvetica", "bold");
        doc.setFontSize(14);
        doc.text(text, 20, y);
        y += 15;
      };

      const field = (label, value, unit = "") => {
        checkPage();

        doc.setFont("helvetica", "bold");
        doc.setFontSize(14);
        doc.text(label, 20, y);

        let x = 20 + doc.getTextWidth(label);

        doc.setFont("helvetica", "normal");
        doc.text(":", x, y);
        x += doc.getTextWidth(": ");

        doc.text(`${value ?? "N/A"}${unit}`, x + 2, y);

        y += 10;
      };

      /* =========================
        HEADER
      ========================== */
      const logoW = 55;
      const logoH = 12;
      const logoX = (pageWidth - logoW) / 2;

      doc.addImage(logoBase64, "PNG", logoX, y, logoW, logoH);
      doc.link(logoX, y, logoW, logoH, {
        url: "https://wisecalc.com.br",
      });

      y += logoH + 25;

      doc.setFont("helvetica", "bold");
      doc.setFontSize(18);
      doc.text("OPENING REINFORCEMENT REPORT (UG-37 TO UG-41)", 20, y);
      y += 14;

      field("Nome do Componente", this.calculo.nomeCalculo);
      field("Tipo de Calculadora", this.calculo.nomeCalculadora);
      field("Autor(a)", this.calculo.autor || "N/A");

      /* =========================
        1. GENERAL SETTINGS
      ========================== */
      y += 10;
      title("1. GENERAL SETTINGS");

      field("Nozzle over shell weld", f.soldaCostado === "1" ? "Yes" : "No");

      /* =========================
        2. PROJECT DATA
      ========================== */
      y += 10;
      title("2. PROJECT DATA");

      field("Design pressure (P)", f.pressaoProjeto, " MPa");
      field("Design temperature (T)", f.temperaturaProjeto, " °C");
      field("Opening internal diameter (d)", f.diametroInternoAbertura, " mm");
      field("Shell internal diameter (D)", f.diametroInternoCasco, " mm");

      /* =========================
        3. EFFICIENCY AND CORROSION
      ========================== */
      y += 10;
      title("3. EFFICIENCY AND CORROSION");

      field("Nozzle welded joint efficiency (En)", f.eficienciaJuntaBocal);
      field("Shell welded joint efficiency (Ev)", f.eficienciaJuntaCasco);
      field("Nozzle corrosion allowance (Can)", f.corrosaoAdmissivelBocal, " mm");
      field("Head or Shell corrosion allowance (Cav)", f.corrosaoAdmissivelCasco, " mm");
      field("Corroded nozzle internal radius (Rn)", f.raioInternoBocalCorroido, " mm");
      field("Reinforcement pad thickness (te)", f.espessuraChapaReforco, " mm");
      field("Allowable stress of reinforcement pad (Se)", f.tensaoAdmissivelChapaReforco, " MPa");
      field("Reinforcement pad diameter (Dp)", f.diametroChapaReforco, " mm");

      /* =========================
        4. MATERIAL DATA
      ========================== */
      y += 10;
      title("4. MATERIAL DATA");

      subtitle("SHELL");

      field("Material", f.materialCasco);
      field("Allowable stress at design temperature (Sv)", f.tensaoAdmissivelCasco, " MPa");
      field("Minimum required thickness", f.espessuraMinimaCasco, " mm");
      field("Nominal thickness", f.espessuraNominalCasco, " mm");
      field("Nominal thickness validation", nominalThicknessValid ? "Nominal Thickness Valid" : "Nominal Thickness Not Valid");
      field("Corroded thickness", f.espessuraCorroidaCasco, " mm");

      y += 5;
      subtitle("NOZZLE");

      field("Material", f.materialSpecification?.materialSpecification);
      field("Allowable stress at design temperature (Sn)", f.tensaoAdmissivelBocal, " MPa");
      field("Minimum required thickness", f.espessuraMinimaBocal, " mm");
      field("Nominal thickness", f.espessuraNominalBocal, " mm");
      field("Corroded thickness", f.espessuraCorroidaBocal, " mm");

      /* =========================
        5. UG-41 LIMITS
      ========================== */
      y += 10;
      title("5. UG-41 LIMITS");

      field("2(d + 2Can)", f.calculo2dMais2Can, " mm");
      field("2(Rn + tn + tv)", f.calculo2RnMaisTnMaisTv, " mm");
      field("Limit diameter (DL)", f.DL, " mm");

      field("2.5tv", f.calculo2ponto5Tv, " mm");
      field("2.5tn + te", f.calculo2ponto5TnMaisTe, " mm");
      field("Limit thickness (TLNP)", f.TLNP, " mm");

      field("Stress ratio Sn/Sv", f.razaoSnSv);
      field("Minimum ratio (Sn/Sv or Sr/Sv)", f.menorSnSvSrSv);
      field("Stress ratio Se/Sv", f.razaoSeSv);
      field("Correction factor (F)", f.fatorCorrecao);

      /* =========================
        6. REINFORCEMENT AREAS
      ========================== */
      y += 10;
      title("6. REINFORCEMENT AREAS");

      field("Required reinforcement area (AR)", f.areaRequerida, " mm²");
      field("Available reinforcement area in shell (A1)", f.A1, " mm²");
      field("Weld area (A2)", f.A2, " mm²");
      field("External weld area (A41)", f.areaSoldaExterna, " mm²");
      field("Pad/Shell weld area (A42)", f.areaSoldaPadCostado, " mm²");
      field("Internal weld area (A43)", f.areaSoldaInterna, " mm²");
      field("Nozzle penetration area (A3)", f.areaBocalPenetraCasco, " mm²");
      field("Reinforcement pad area (A5)", f.areaChapaReforco, " mm²");
      field("Total reinforcement area (AT)", f.areaTotalReforco, " mm²");
      field("Reinforcement check result", f.resultadoRefoço);

      /* =========================
        7. RESULT
      ========================== */
      y += 10;
      title("7. RESULT");

      field("Final verification result", f.resultado);

      /* =========================
        8. WELD LOADS
      ========================== */
      y += 10;
      title("8. WELD LOADS");

      field("Total load on welds (F)", f.cargaTotalSoldas, " N");
      field("Load on failure line 1-1 (F1)", f.cargaLinhaFalha11, " N");
      field("Load on failure line 2-2 (F2)", f.cargaLinhaFalha22, " N");
      field("Load on failure line 3-3 (F3)", f.cargaLinhaFalha33, " N");

      /* =========================
        9. RESISTANCE
      ========================== */
      y += 10;
      title("9. RESISTANCE");

      field("Allowable weld stress (S)", f.tensaoAdmissivelSoldas, " MPa");
      field("Shear stress weld pad/shell (R1)", f.cisalhamentoSoldaPadCasco, " N");
      field("Shear stress weld nozzle/pad (R2)", f.cisalhamentoSoldaBocalPad, " N");
      field("Tensile stress weld pad/shell (R3)", f.tracaoSoldaTopoPadCasco, " N");
      field("Tensile stress weld shell/nozzle (R4)", f.tracaoSoldaTopoCascoBocal, " N");
      field("Nozzle resistance (R5)", f.resistenciaBocal, " N");
      field("Reinforcement pad resistance (R6)", f.resistenciaChapaReforco, " N");

      /* =========================
        10. FAILURE LINES
      ========================== */
      y += 10;
      title("10. FAILURE LINE STRENGTH");

      field("Failure line resistance 1-1 (R11)", f.resistenciaLinha11, " N");
      field("Verification result 1-1", f.resultadoLinha11);

      field("Failure line resistance 2-2 (R22)", f.resistenciaLinha22, " N");
      field("Verification result 2-2", f.resultadoLinha22);

      field("Failure line resistance 3-3 (R33)", f.resistenciaLinha33, " N");
      field("Verification result 3-3", f.resultadoLinha33);

      field("Reinforcement pad verification", f.resultadoChapaReforco);

      /* =========================
        11. FLANGE DATA
      ========================== */
      y += 10;
      title("11. FLANGE DATA");

      field("Flange material", f.materialFlange);
      field("Pressure rating", f.pressureRating);
      field("Working allowable pressure (WAMP)", f.wamp, " MPa");

      /* =========================
        12. UG-45
      ========================== */
      y += 10;
      title("12. MINIMUM NOZZLE THICKNESS (UG-45)");

      field("Design pressure (P)", f.pressaoProjeto, " MPa");
      field("Allowable stress (S)", f.tensaoAdmissivelBocal, " MPa");
      field("External diameter of nozzle (De)", f.externalRadiusNozzle, " mm");
      field("Weld efficiency (E)", f.eficienciaJuntaBocal);
      field("Corrosion allowance (CA)", f.corrosaoAdmissivelBocal, " mm");
      field("Calculated thickness (ta)", f.thicknessTa, " mm");
      field("UG-45 thickness requirement", f.ug45, " mm");
      field("Minimum required thickness (t)", f.minThicknessUG45, " mm");

      y += 5;
      subtitle("DRAWING");

      const drawingWidth = 140;
      const drawingHeight = 99;
      const drawingX = (pageWidth - drawingWidth) / 2;
      const legendWidth = 140;
      const legendGap = 8;

      const legendImage = new window.Image();
      const legendImageLoaded = new Promise((resolve, reject) => {
        legendImage.onload = resolve;
        legendImage.onerror = reject;
      });
      legendImage.src = legendaDrawingBocal;
      await legendImageLoaded;

      const legendHeight = legendWidth * legendImage.naturalHeight / legendImage.naturalWidth;
      const legendX = (pageWidth - legendWidth) / 2;

      checkPage(drawingHeight + legendGap + legendHeight + 20);
      doc.addImage(drawingBocalBase64, "PNG", drawingX, y, drawingWidth, drawingHeight);
      y += drawingHeight + legendGap;
      doc.addImage(legendImage, "PNG", legendX, y, legendWidth, legendHeight);
      y += legendHeight;

      this.adicionarPaginacao(doc);
      doc.save(`(WISECALC) ${this.calculo.nomeCalculo}.pdf`);
      this.fecharLoading();
    }

  }
};
</script>

<style scoped>
.documento {
  width: 210mm;
  min-height: 297mm;
  padding: 20mm;
  background: white;
  font-family: 'Arial', sans-serif;
  font-size: 14px;
  position: relative;
  box-sizing: border-box;
}

.cabecalho {
  text-align: center;
  border-bottom: 2px solid #000;
  margin-bottom: 20px;
}

.cabecalho .logo {
  width: 80px;
  margin-bottom: 10px;
}

.conteudo {
  margin-top: 20px;
}

.conteudo p {
  margin-bottom: 10px;
}

.rodape {
  position: absolute;
  bottom: 20mm;
  left: 0;
  width: 100%;
  text-align: center;
  font-size: 12px;
  color: gray;
  border-top: 1px solid #ccc;
  padding-top: 5px;
}

.botao-outline-azul{
  border-color: #0056FF;
  background-color: white;
  color: #0056FF;
  font-weight: 600;
  height: 40px !important;
}

.botao-outline-azul:hover{
  border-color: #0056FF;
  background-color: #0056FF;
  color: white;
  font-weight: 600;
}

.img-componente-calc{
  width: 150px;
}

.bocal-formulario-cabecalho {
  margin: 0 0 20px;
}

.bocal-formulario-cabecalho h2 {
  margin: 0 0 6px;
  padding-left: 12px;
  border-left: 4px solid #0056ff;
  color: #0056ff;
  font-size: 1.25rem;
  font-weight: 800;
}

.bocal-formulario-cabecalho p {
  margin: 0;
  color: #596579;
  font-size: 0.875rem;
}

/* APENAS CELULAR */
@media (max-width: 575px) {
    .input {
        width: 150px;
    }

    .form-select{
        display: block !important;
    }

    .img-componente-calc{
      width: 150px;
    }

}

/* TABLET */
@media (min-width: 768px) and (max-width: 991px) {
    .img-componente-calc{
      width: 125px;
    }
}
</style>